import axios, { AxiosPromise } from "axios";
import { ApiResponseMeta } from "../../../models/apiResponseMeta";
import { EnvironmentDetails } from "../models/environment";
import { visiblyApiConfig } from "../../../config";

const axiosInscance = axios.create({
  baseURL: visiblyApiConfig.baseUrl,
});

type GetEnvironmentDetailsResponse = {
  data: EnvironmentDetails;
  meta: ApiResponseMeta;
};

async function getEnvironmentDetailsAsync(): Promise<
  AxiosPromise<GetEnvironmentDetailsResponse>
> {
  return await axiosInscance.get("environments/v1");
}

export { getEnvironmentDetailsAsync };
